var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showText),expression:"showText"}],domProps:{"innerHTML":_vm._s(_vm.texts[_vm.textIdx])}})])}
var staticRenderFns = []

export { render, staticRenderFns }